<div class="campaign-container">
  <div class="campaign-selection-wrapper">
    <div class="campaign-list">
      <achoo-filter-box
        class="full-width"
        placeholder="{{'INFLUENCER.campaign.campaign_list_placeholder' | translate}}"
        [options]="campaignList"
        name="campaignSelection"
        (selectEvent)="onSelectCampaign($event)"
        [(model)]="selectedCampaignInfluencerId">
      </achoo-filter-box>
    </div>
  </div>
  <div *ngIf="selectedCampaign">
    <achoo-placeholder [placeholderId]="'influencerCampaignDetailsHolder'" [normalPlaceholder]="true" [isFullscreenLoader]="false">
      <div class="d-flex flex-row">
        <div class="full-width ellipsis campaign-description">
          <span>{{selectedCampaign.description}}</span>
        </div>
      </div>
      <div class="d-flex flex-row">
        <div class="full-width campaign-slider-container">
          <campaign-influencer-status-slider
            *ngIf="selectedCampaign.status"
            [readonly]="isReadOnly"
            [slider]="campaignSilder"
            (changeStatus)="changeStatus($event)">
          </campaign-influencer-status-slider>
        </div>
      </div>
    </achoo-placeholder>
    <div class="d-flex flex-row kpi-container">
        <kpi-report
          class="full-width"
          [kpi]="campaignInfluencerKPI"
          [showKpiStatus]="false"
        ></kpi-report>
    </div>
  </div>
  <div class="d-flex flex-row">
    <div class="full-width post-list-container">
      <campaign-influencer-posts
        [posts]="campaignPosts"
        [influencerId]="influencerId"
        [originalFromPath]="fromPath"
        [campaignInfluencerId]="selectedCampaignInfluencerId"
        (selectPost)="onSelectPost($event)">
      </campaign-influencer-posts>
    </div>
  </div>
</div>

<achoo-popup #AlertUpdateInfluencerCampaignStatusSuccess
             [isNotification]="true"
             (cancelCallback)="closeModalDialog()"
             modelTitle="{{'notification.success' | translate}}">
  <div class="d-flex flex-row flex-auto">
    <span>{{'INFLUENCER.campaign.update_influencer_campaign_status' | translate: {from: previousStt, to: currentStt} }}</span>
  </div>
</achoo-popup>



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-campaign-activity/influencer-campaign-activity.component.html